import RequiredSkills from "../../../../../common/requiredSkills/RequiredSkills";
import SearchJobseakerHeader from "../../../../../common/searchJobseakerHeader/SearchJobseakerHeader";

function HtmlSkill() {
  return (
    <>
      <SearchJobseakerHeader />
      <RequiredSkills />
    </>
  );
}
export default HtmlSkill;
